/** Nhãn trạng thái luồng ký hợp đồng nhượng quyền (đồng bộ admin / chủ phòng / trang ký công khai). */
export const FRANCHISE_CONTRACT_STATUS_LABEL = {
  not_sent: "Bản nháp",
  sent: "Đã gửi",
  viewed: "Đã xem",
  signed: "Đã ký",
  completed: "Hoàn tất",
  void: "Vô hiệu",
};
